import { useState } from 'react';
import { BsChevronCompactDown } from 'react-icons/bs';
import firebase from 'firebase';
import 'firebase/firestore';

const Settings = () => {
	const firestore = firebase.firestore();
	const phone = localStorage.getItem('user-phone');
	const ref = firestore.doc(`users/${phone}`);
	const [name, setName] = useState('');
	const [caption, setCaption] = useState('');
	const styling = {
		color: '',
	};

	function updateDet() {
		if (name) {
			ref.update({
				name: name,
			});
		}
		if (caption) {
			ref.update({
				caption: caption,
			});
		}

        alert('Done')
	}

	return (
		<div className="settings-page flex-col-start page">
			<div className="set-header flex-start">
				<h2>settings</h2>
			</div>
			<div className="settings-cont flex-col-start">
				<span
					className="setting-sign flex-evenly"
					onClick={(e) => {
						if (e.target.className === 'setting-sign flex-evenly') {
							e.target.parentElement.style.minHeight = '400px';
							e.target.nextElementSibling.style.display = 'flex';
						}
					}}
				>
					Change your details
					<BsChevronCompactDown style={styling} />
				</span>

				<div className="set-drop-down flex-col-evenly">
					<input
						type="text"
						placeholder="change name"
						onChange={(e) => {
							setName(e.target.value);
						}}
					/>
					<input
						type="text"
						placeholder="change caption"
						onChange={(e) => {
							setCaption(e.target.value);
						}}
					/>

					<button onClick={(e) => updateDet()}>Change</button>

					<small
						className="flex-start"
						onClick={(e) => {
							e.target.parentElement.parentElement.style.minHeight = '40px';
							e.target.parentElement.style.display = 'none';
						}}
					>
						close
					</small>
				</div>
			</div>

			<div className="set-one-action flex"></div>
		</div>
	);
};

export default Settings;
